module.exports = __webpack_public_path__ + "static/img/join.c8b13c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/join.png
// module id = HuG0
// module chunks = 1